import React from 'react';
import { FooterArea } from './styled';

const Footer = () => {
    return (
        <FooterArea>
            Todos os direitos reservados<br/>
            
        </FooterArea>
    );
}

export default Footer;
